import React, { Component } from 'react';

import "@material/react-chips/dist/chips.css";
import NavBar from '../../shared/NavBar';
import {Col, Row, Button, Input, Badge, InputGroup, InputGroupAddon, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Jumbotron, Card, CardHeader, CardBody} from 'reactstrap';

import {connect} from "react-redux";
import axios from 'axios';

import './Incentives.css';

class Incentives extends Component {

    state = {
        selectedFile: null
    }

    componentDidMount() {
        // this.getDevUsers();
    }

    onFileChange = event => {
        this.setState({ selectedFile: event.target.files[0] });
    }

    onFileUpload = () => {
        if (this.state.selectedFile) {
            
            var tmpFile = new File([this.state.selectedFile], "t1.jpg");

            axios.put(
                'https://api.iondeveloper.com/admin/incentiveImages/', 
                tmpFile, 
                { headers: { 'Content-Type': 'image/jpeg' } }
            ).then(function(response) {
                // console.log(response);
                return response.data;
            }).then(function(data) {
                if (data.success){
                    alert("Uploaded successfully!");
                }
            }.bind(this));
        }
    }

    fileData = () => {
    
        if (this.state.selectedFile) {
           
            return (
            <div>
                <img className='preview-image' src={URL.createObjectURL(this.state.selectedFile)}></img>
            </div>
            );
        } else {
            return (
            <div>
                <br />
                <p>Choose before Pressing the Upload button</p>
            </div>
            );
        }
    };
    

    /*** SETTER ***/


    
    render() {
        return (
            <div>
                <NavBar />
                <div className="container">
                    <div className="email-container">
                        <h4><b>Incentives Upload</b> </h4>
                        <Jumbotron>
                            <hr />
                            <p>Select the Image you're replacing the current one with.</p>
                            <InputGroup>
                                <label className='custom-file-upload'>
                                    <Input type="file" placeholder="Select a new Image to Upload" name="file" onChange={this.onFileChange} />
                                    Select Image
                                </label>
                                <InputGroupAddon addontype="append">
                                    <Button color="dark" onClick={this.onFileUpload}>Upload</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </Jumbotron>
                        {this.fileData()}
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Incentives);


// WEBPACK FOOTER //
// ./src/components/pages/Incentives/Incentives.js